import type { CustomFlowbiteTheme } from 'flowbite-react';

export const accordionTheme: CustomFlowbiteTheme['accordion'] = {
  root: {
    base: 'divide-y divide-gray-200 border-none',
    flush: {
      off: 'rounded-lg border',
      on: 'border-b',
    },
  },
  content: {
    base: 'px-5 py-5 first:rounded-t-lg last:rounded-b-lg',
  },
  title: {
    arrow: {
      base: 'h-6 w-6 shrink-0',
      open: {
        off: '',
        on: 'rotate-180',
      },
    },
    base: 'flex w-full items-center justify-between px-5 py-5 text-left font-medium text-titan-night-900 first:rounded-t-lg last:rounded-b-lg',
    flush: {
      off: 'hover:bg-gray-100',
      on: 'bg-transparent',
    },
    heading: 'max-w-[80%] sm:max-w-none',
    open: {
      off: '',
      on: 'text-titan-night-900',
    },
  },
};
